import { useEffect, useState } from "react";
import { Images } from "lucide-react";
import api from "../lib/api";

export function MarqueeStrip({ testid = "marquee-strip" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/public/marquee").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const doubled = [...items, ...items];

  return (
    <section data-testid={testid} className="py-10 overflow-hidden">
      <style>{`
        @keyframes marquee-x { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .marquee-track { animation: marquee-x 55s linear infinite; }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
      <div className="max-w-6xl mx-auto px-5 flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-turq-600 flex items-center justify-center">
          <Images className="w-5 h-5 text-white" />
        </div>
        <div>
          <h2 className="font-head font-black text-2xl">لوحة العطاء المتحركة</h2>
          <p className="text-xs text-mutext">لقطات حيّة من ميادين التطوع في مدارس الشرقية — تتحرك دائماً كعطائهم الذي لا يتوقف</p>
        </div>
      </div>
      <div className="relative" dir="ltr">
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 z-10 bg-gradient-to-l from-bg to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 z-10 bg-gradient-to-r from-bg to-transparent" />
        <div className="marquee-track flex w-max gap-4 px-2">
          {doubled.map((it, i) => (
            <figure key={`${it.id}-${i}`}
              data-testid={i < items.length ? `marquee-item-${it.id.slice(0, 8)}` : undefined}
              className="relative w-64 h-40 shrink-0 rounded-2xl overflow-hidden border border-brd shadow-md shadow-turq-900/10 group">
              <img src={it.image} alt={it.caption || "صورة تطوعية"} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              {it.caption && (
                <figcaption dir="rtl"
                  className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent text-white text-[11px] font-bold px-3 py-2 text-right">
                  {it.caption}
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
